import { dcolors } from "corexxx";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { SimpleStoreClient } from "../libs/common_ts/SimpleStoreClient";
import { DefaultAccountScreen } from "../libs/components/screens/DefaultAccountScreen";
import { DefaultPageInProgress } from "../libs/components/screens/DefaultPageInProgress";
import { DReactLiveEditorPage } from "../libs/components/screens/DReactLiveEditorPage";
import { TAppConfig, setAppConfig } from "../libs/dweb/DAppCommand";
import { DAppInit } from "../libs/dweb/DAppInit";
import { DAppWrapper } from "../libs/dweb/DAppWrapper";
import { DHelmet } from "../libs/dweb/DHelmet";
import { DPageLoadingWrapper } from "../libs/dweb/DPageLoadingWrapper";
import { DResponsiveWindow } from "../libs/dweb/DResponsiveWindow";
import { DashBoard } from "./views/DashboardPage";
import { LandingPage, LandingPageBase } from "./views/LandingPage";
import { MortageCalculator } from "../libs/components/tools_screen/MortageCalculator";
import { YearBudget } from "./views/YearBudgetPage";
import { Opertunities } from "./views/Opertunities";
import { GrowthAnalysis } from "./views/GowthAnalysis";
import { DefaultOAuthHandlerScreen } from "../libs/components/screens/DefaultOAuthHandler";

// Step1: Init
let appConfig: TAppConfig = {
  app_id: "grodok_money",
  app_name: "Grodok Money",
  primary_color: dcolors.pallets.red900,
  dark: false,
  app_slogan: "Experience Smarter Financial Management with Grodok Money",
  app_subtext: "Experience Smarter Financial Management with Grodok Money",
  logo: require("./focus/favicon_io/android-chrome-512x512.png"),
};
SimpleStoreClient.Get().init(appConfig);
setAppConfig(appConfig);

export function DBasePage({ children }: { children: any }) {
  return (
    <DPageLoadingWrapper style={{ marginTop: 20 }} stickyNotification>
      <DResponsiveWindow>{children}</DResponsiveWindow>
    </DPageLoadingWrapper>
  );
}

function App() {
  return (
    <RecoilRoot>
      <DHelmet config={{ page_title: appConfig.app_slogan }} />
      <DAppWrapper>
        <BrowserRouter>
          <DAppInit appConfig={appConfig} />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/account" element={<DefaultAccountScreen />} />
            <Route path="/dashboard" element={<DashBoard />} />
            <Route path="/test" element={<DReactLiveEditorPage />} />
            <Route
              path="/oauth/:provider"
              element={<DefaultOAuthHandlerScreen />}
            />
            <Route
              path="/free_tool/mc"
              element={
                <LandingPageBase>
                  <MortageCalculator />
                </LandingPageBase>
              }
            />
            <Route
              path="/free_tool/yb"
              element={
                <LandingPageBase>
                  <YearBudget />
                </LandingPageBase>
              }
            />
            <Route
              path="/free_tool/op"
              element={
                <LandingPageBase>
                  <Opertunities />
                </LandingPageBase>
              }
            />
            <Route
              path="/free_tool/growth"
              element={
                <LandingPageBase>
                  <GrowthAnalysis />
                </LandingPageBase>
              }
            />
            <Route path="*" element={<DefaultPageInProgress />} />
          </Routes>
        </BrowserRouter>
      </DAppWrapper>
    </RecoilRoot>
  );
}

export default App;
